export default {
  personalData: 'prouniPersonalData',
  personalDocuments: 'prouniPersonalDocuments',
  residence: 'prouniResidence',
  familyIncome: 'prouniFamilyIncome',
  education: 'prouniEducation',
  acceptance: 'prouniAcceptance',
};
